__turbopack_context__.v({
  "container": "shareButtons-module-scss-module__hFSKBW__container",
  "email": "shareButtons-module-scss-module__hFSKBW__email",
  "facebook": "shareButtons-module-scss-module__hFSKBW__facebook",
  "icon": "shareButtons-module-scss-module__hFSKBW__icon",
  "iconContainer": "shareButtons-module-scss-module__hFSKBW__iconContainer",
  "pinterest": "shareButtons-module-scss-module__hFSKBW__pinterest",
  "reddit": "shareButtons-module-scss-module__hFSKBW__reddit",
  "shareButtons": "shareButtons-module-scss-module__hFSKBW__shareButtons",
  "title": "shareButtons-module-scss-module__hFSKBW__title",
  "twitter": "shareButtons-module-scss-module__hFSKBW__twitter",
});
